/**
 * 동적 메타 라벨 리졸버
 *
 * 동적 메타모델 원칙: workitem_type·field_def·code 등의 표시 텍스트는
 * 서버가 내려주는 *_i18n JSONB(`{ko,en,zh,ja}`)에서 현재 언어로 해석함.
 * 모듈별 하드코딩 라벨 금지.
 *
 * @param base  폴백 라벨 (기본 컬럼 name/label, 보통 영문)
 * @param i18n  서버가 내려준 다국어 맵 (`{ "ko": "...", "en": "..." }`) — 없을 수 있음
 * @param lang  현재 UI 언어 코드 (ko/en/zh/ja)
 * @returns     현재 언어 라벨, 없으면 base 폴백
 */
import { readKey } from "@/lib/safeAccess";

export function resolveLabel(
  base: string,
  i18n: Record<string, string | undefined> | undefined | null,
  lang: string,
): string {
  return (i18n && readKey(i18n, lang)) || base;
}
